"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.excludeNextjsTelemetryProcessor = void 0;
/**
 * Excludes Next.js telemetry from the given envelope.
 *
 * @param envelope The telemetry envelope to process.
 * @returns A boolean indicating whether the telemetry should be excluded.
 */ var excludeNextjsTelemetryProcessor = function(envelope) {
    var _envelope_data_baseData;
    // Next.js telemetry always contains this property
    if ('next.span_type' in ((_envelope_data_baseData = envelope.data.baseData) === null || _envelope_data_baseData === void 0 ? void 0 : _envelope_data_baseData.properties)) {
        return false;
    }
    return true;
};
exports.excludeNextjsTelemetryProcessor = excludeNextjsTelemetryProcessor; //# sourceMappingURL=excludeNextjsTelemetryProcessor.js.map
